import { Component, ChangeDetectionStrategy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { OptionComponent } from '../abstract/option.component';
import { optionAfterschoolMinValidator } from './option-afterschool-min-validator.fn';
import { optionAfterschoolDuplicateValidator } from './option-afterschool-dulicate-validator.fn'; 
import { NgModel, Validators } from '@angular/forms';
import { AfterschoolComposeService } from './modals/afterschool-compose/afterschool-compose.service';

@Component({
  selector: 'option-afterschool',
  styleUrls: ['./option-afterschool.component.css'], 
  templateUrl: './option-afterschool.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
 
})
export class OptionAfterschoolComponent extends OptionComponent {
  constructor (
    cdRef:ChangeDetectorRef,
    private composeModal:AfterschoolComposeService,
  ) {
    super(cdRef)
  }
  @ViewChild('accept') accept:NgModel;
  @ViewChild('waitlist') waitlist:NgModel;
  ngOnInit () {
    super.ngOnInit();
    if (this.accept) {
      this.waitlist.control.setValidators([Validators.min(0), Validators.max(999), Validators.required]);
      this.optionFormGroup.setControl('accept', this.accept.control);
    }  
    if (this.waitlist) {
      this.waitlist.control.setValidators([Validators.min(0), Validators.max(999), Validators.required]);
      this.optionFormGroup.setControl('waitlist', this.waitlist.control);
    }  
    if (this.text) this.text.control.setValidators(
      [optionAfterschoolMinValidator(this.option), optionAfterschoolDuplicateValidator(this.option)]
    );
    this.subscriptions.push(this.option.question.getChildTracker(['options']).onContentUpdate.subscribe(()=>{
      this.refreshView();
    }));    
    this.subscriptions.push(this.option.question.getChildTracker(['canHaveQuotaOptions']).onContentUpdate.subscribe(()=>{
      this.refreshView();
    }));    
  }
  write () {
    this.composeModal.open(this.option);
  }
  refreshView() {
    if (this.text) this.text.control.updateValueAndValidity();
    super.refreshView();
  }
  ngOnDestroy () {
    if (this.accept) this.optionFormGroup.removeControl('accept');
    if (this.waitlist) this.optionFormGroup.removeControl('waitlist');
    super.ngOnDestroy();
  }
  // onFocus ($event:MouseEvent) {
  //   (<HTMLTextAreaElement>$event.target).click();
  // }
}
